import { render } from "./GeneralSettingsMenu.vue?vue&type=template&id=7cf0561f&scoped=true&ts=true&lang=pug"
import script from "./GeneralSettingsMenu.vue?vue&type=script&lang=ts"
export * from "./GeneralSettingsMenu.vue?vue&type=script&lang=ts"

import "./GeneralSettingsMenu.vue?vue&type=style&index=0&id=7cf0561f&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf0561f"]])

export default __exports__